import {
	CAMERA_ERROR,
	STORAGE_ERROR,
	type CameraError,
	type StorageError,
} from '../types/camera-errors';

/**
 * Transient states where the storage is mid-operation. While any of these is
 * active the UI should show a loader instead of a usage/error indicator.
 */
export const STORAGE_BUSY_ERRORS: StorageError[] = [
	STORAGE_ERROR.MOUNTING,
	STORAGE_ERROR.MOUNTING_NFS,
	STORAGE_ERROR.MOUNTING_CIFS,
	STORAGE_ERROR.UNMOUNTING_NFS,
	STORAGE_ERROR.UNMOUNTING_CIFS,
	STORAGE_ERROR.RESOLVING_NFS_HOST,
	STORAGE_ERROR.RESOLVING_CIFS_HOST,
	STORAGE_ERROR.WAITING_FOR_NETWORK,
	STORAGE_ERROR.FORMATTING,
];

/**
 * Maps each storage error/state to a translatable label shown in the storage UI.
 */
export const STORAGE_STATE_LABELS: Record<StorageError, { key: string; default: string }> = {
	[STORAGE_ERROR.NEEDS_FORMATTING]: {
		key: 'camera_storage_state_needs_format',
		default: 'Needs format',
	},
	[STORAGE_ERROR.MOUNTING]: { key: 'camera_storage_state_mounting', default: 'Mounting...' },
	[STORAGE_ERROR.MOUNT_FAILED]: {
		key: 'camera_storage_state_mount_failed',
		default: 'Mount failed',
	},
	[STORAGE_ERROR.MOUNTING_NFS]: {
		key: 'camera_storage_state_mounting_nfs',
		default: 'Mounting NFS share...',
	},
	[STORAGE_ERROR.MOUNTING_CIFS]: {
		key: 'camera_storage_state_mounting_cifs',
		default: 'Mounting share...',
	},
	[STORAGE_ERROR.UNMOUNTING_NFS]: {
		key: 'camera_storage_state_unmounting_nfs',
		default: 'Unmounting NFS share...',
	},
	[STORAGE_ERROR.UNMOUNTING_CIFS]: {
		key: 'camera_storage_state_unmounting_cifs',
		default: 'Unmounting share...',
	},
	[STORAGE_ERROR.UNMOUNT_FAILED]: {
		key: 'camera_storage_state_unmount_failed',
		default: 'Unmount failed',
	},
	[STORAGE_ERROR.RESOLVING_NFS_HOST]: {
		key: 'camera_storage_state_resolving_nfs_host',
		default: 'Resolving NFS host...',
	},
	[STORAGE_ERROR.RESOLVING_CIFS_HOST]: {
		key: 'camera_storage_state_resolving_cifs_host',
		default: 'Resolving host...',
	},
	[STORAGE_ERROR.FILESYSTEM_ERROR]: {
		key: 'camera_storage_state_filesystem_error',
		default: 'Filesystem error',
	},
	[STORAGE_ERROR.WAITING_FOR_NETWORK]: {
		key: 'camera_storage_state_waiting_for_network',
		default: 'Waiting for network...',
	},
	[STORAGE_ERROR.FORMATTING]: {
		key: 'camera_storage_state_formatting',
		default: 'Formatting...',
	},
	[STORAGE_ERROR.FORMAT_FAILED]: {
		key: 'camera_storage_state_format_failed',
		default: 'Format failed',
	},
	[STORAGE_ERROR.EJECT_FAILED]: {
		key: 'camera_storage_state_eject_failed',
		default: 'Eject failed',
	},
	[STORAGE_ERROR.EJECTED]: { key: 'camera_storage_state_ejected', default: 'Ejected' },
};

/**
 * Maps each camera component error to a translatable label shown in the camera UI.
 */
export const CAMERA_ERROR_LABELS: Record<CameraError, { key: string; default: string }> = {
	[CAMERA_ERROR.STREAMER_FS_BAD]: {
		key: 'camera_error_streamer_fs_bad',
		default: 'Streamer update required',
	},
};
